export const breakpoints = {
    sm: '640px',
    md: '800px',
    lg: '1200px',
    xl: '1600px',
};
